//
import AssetDiscountModel from '@/models/HumanResource/HrAssetDiscount'
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import EmployeeModel from '@/models/HumanResource/HrEmployee'

//
import AssetDiscountHeaders from '@/views/HumanResource/HrAssetDiscount/HrAssetDiscountHeaders'
import SalarySettlementHeadersCreate from '@/views/HumanResource/HrSalarySettlement/partials/HrSalarySettlementHeadersCreate'

//
import { NoNegativeRule, RequiredRule } from '@/mixins/reusable_mixins/rules'

//
export default props => [
    {
        name: 'hr_employee_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noDataText: 'Sin empleados',
            noObject: true,
            paramSearch: 'names',
            rules: [RequiredRule],
        },
        trigger(ctx) {
            //
            const apv_afp = ctx.getField('apv_afp')
            const employee = ctx.getInput('hr_employee_id').getSelected(),
                hasContract = !!employee.active_contract,
                hasAssets =
                    hasContract &&
                    !!employee.active_contract.hr_contract_asset_discount
            //
            if (hasContract && hasAssets && !ctx.value.id) {
                ctx.value.hr_contract = employee.active_contract
                ctx.value.selected = employee.active_contract.hr_contract_asset_discount.map(
                    item => {
                        return {
                            id: item.hr_asset_discount_id,
                            name: item.hr_asset_discount.name,
                            amount: item.amount,
                        }
                    }
                )
            }

            //
            if(!ctx.value.id) {
                ctx.value.apv = employee.hr_employee_apv.apv
                ctx.value.apv_afp = employee.hr_employee_apv.apv_afp 
            }

            //
            apv_afp.props.disabled = employee.hr_prevision.code == "00"

            //
            ctx.getFieldset().$forceUpdate()
        },
    },
    {
        name: 'period',
        type: 'date-field',
        props: {
            label: 'Periodo',
            pickerProps: {
                allowedDates: val => props.indicators.some(({ period_month, period_year }) => {
                    return (
                        Number(val.split('-')[1]) === period_month &&
                        Number(val.split('-')[0]) === period_year
                    )
                }),
                type: 'month',
            },
            rules: [RequiredRule],
        },
    },
    {
        name: 'hr_contract_type_name',
        type: 'text-field',
        props: {
            label: 'Contrato',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'worked_days',
        type: 'text-field',
        props: {
            label: 'Dias trabajados',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'extra_hh_hours',
        type: 'float-field',
        props: {
            label: 'Horas extras',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'extra_hh_minutes',
        type: 'float-field',
        props: {
            label: 'Minutos extras',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'discount_hh_hours',
        type: 'float-field',
        props: {
            label: 'Horas descontadas',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'discount_hh_minutes',
        type: 'float-field',
        props: {
            label: 'Minutos descontados',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'd-grid': true,
            xs12: true,
        },
        props: {
            headers: SalarySettlementHeadersCreate,
            noDataText: 'Sin haberes y descuentos.',
            pickerProps: {
                headers: AssetDiscountHeaders,
                mapper: row => {
                    //
                    row.periodic = true
                    row.new_periodic_month = '2019-01'
                    row.amount = 0
                    //
                    return row
                },
                noSearch: true,
                service: AssetDiscountModel,
            },
            showPicker: true,
            toolbarTitle: 'Haberes y descuentos',
        },
    },
    {
        name: 'bonuses',
        type: 'currency-field',
        props: {
            label: 'Bonos',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'advance',
        type: 'currency-field',
        props: {
            label: 'Avance',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'apv',
        type: 'currency-field',
        props: {
            label: 'APV',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'apv_afp',
        type: 'currency-field',
        props: {
            label: 'Cuenta 2 de la AFP',
            reverse: true,
            rules: [NoNegativeRule],
        },
    },
    {
        name: 'base_salary_proportional_calculated',
        type: 'currency-field',
        props: {
            label: 'Salario base',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'loan_ccaf_quote_amount',
        type: 'currency-field',
        props: {
            label: 'Dscto. CCAF',
            reverse: true,
        },
    },
    {
        name: 'unique_tax_amount',
        type: 'currency-field',
        props: {
            label: 'Impuesto único',
            reverse: true,
        },
    },
    {
        name: 'acc_cost_center_id',
        type: 'autocomplete-model',
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Centro de costo',
            model: CostCenterModel,
            noDataText: 'Sin Centro de costo',
            noObject: true,
            paramSearch: 'name',
            rules: [RequiredRule],
        },
    },
]
